
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkouta",
      function () {
        return require("private-next-pages/checkouta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkouta"])
      });
    }
  